import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png'
import { countTotal } from '../redux/cart/actionCreator';

const Navbar = () => {
  const dispatch = useDispatch();
  const {cart, totalCount} = useSelector((state) => state.cart);

  useEffect(() => {
    dispatch(countTotal());
  },[cart])

    return (
        <nav className="bg-[#171C2A] py-4">
    <div className="navBar">
      <Link to='/' href="index.html">
        <img src={logo} alt="LWS" className="max-w-[140px]" />
      </Link>

      <div className="flex gap-4">
        <Link to='/' className="navHome" id="lws-home"> Home </Link>
        <Link to='/cart' className="navCart" id="lws-cart">
          <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
          <span id="lws-totalCart">{totalCount}</span>
        </Link>
      </div>
    </div>
  </nav>
    );
};

export default Navbar;